// extracted by mini-css-extract-plugin
export default {"page-cms":"Page_page-cms__Sy8PV"};